import store from "@shared/scripts/utils/store";
import { openModal } from "@shared/scripts/actions/modal";
import { getDocumentFile } from "@shared/scripts/features/api";
import { isMobile } from "@shared/scripts/utils/tool";

export default () => {
  // eslint-disable-next-line no-undef
  if (!isMobile()) {
    $("#js-get-document").on("click", function() {
      const { email, id } = this.dataset;
      getDocumentFile(id);
      store.dispatch(
        openModal("document", {
          email,
        })
      );
    });

    $("#js-pro-document").on("click", function() {
      const { url, apply_pending } = this.dataset;
      store.dispatch(openModal("charge", { url, apply_pending }));
    });
  } else {
    const $modal = $("#js-document-modal");
    const $modalContent = $("#js-modal-content");
    const $closeBtn = $(".js-close-modal");
    const closeModal = () => $modal.removeClass("is-show");

    $modal.on("click", closeModal);

    $modalContent.on("click", event => {
      event.stopPropagation();
    });

    $closeBtn.on("click", closeModal);

    $("#js-get-document").on("click", function() {
      getDocumentFile(this.dataset.id);
      $modal.addClass("is-show");
    });
  }
};
